export default __webpack_public_path__ + "static/media/sign.d91f886c.png";